// Minimal callable node:assert stand-in.
function assert(value, message) {
    if (!value) {
        throw new Error(message ?? "Assertion failed");
    }
}

assert.ok = assert;
assert.strict = assert;
assert.equal = (actual, expected, message) =>
    // eslint-disable-next-line eqeqeq
    assert(actual == expected, message ?? `${actual} != ${expected}`);
assert.strictEqual = (actual, expected, message) =>
    assert(actual === expected, message ?? `${actual} !== ${expected}`);
assert.notEqual = (actual, expected, message) =>
    // eslint-disable-next-line eqeqeq
    assert(actual != expected, message);
assert.notStrictEqual = (actual, expected, message) =>
    assert(actual !== expected, message);
assert.deepEqual = () => undefined;
assert.deepStrictEqual = () => undefined;
assert.fail = (message) => {
    throw new Error(message ?? "Assertion failed");
};

module.exports = assert;
